// extracted by mini-css-extract-plugin
export default {"circleStep":"StepCircle_circleStep__YUsnY","big":"StepCircle_big__+88Gp","middle":"StepCircle_middle__U2SNz","small":"StepCircle_small__4qtbN"};